import React, { Fragment } from "react";
import styled from "styled-components";
import { withDeprecation } from "components/Common/WithDeprecation";

// visually hidden but read by screen readers
const IconAltText = styled.span`
  clip: rect(0 0 0 0);
  @supports (clip-path: polygon(0 0, 0 0, 0 0, 0 0)) {
    clip-path: polygon(0 0, 0 0, 0 0, 0 0);
  }
  overflow: hidden;
  position: absolute;
  height: 1px;
  width: 1px;
`;

/**
 * Hides icon from screen readers, adds 'alt text' that's visible to screen readers
 * but visually hidden, adds a title attribute to offer more context on hover
 */
const FontIcon = props => {
  const { altText, titleText, className } = props;
  const title = titleText ? titleText : altText;

  return (
    <Fragment>
      <i title={title} className={className} aria-hidden="true" />
      <IconAltText>{altText}</IconAltText>
    </Fragment>
  );
};

export default withDeprecation(
  FontIcon,
  "Please use <CFontIcon /> instead of <FontIcon />.",
  "https://designcu.es/components/fonticons"
);
